import TwoColumnLayout from '../layouts/TwoColumnLayout'
import Sidebar from "../components/leftContent/Sidebar";

export default function Blog({rightContent}) {
    return (
        <TwoColumnLayout leftContent={<Sidebar/>} rightContent={rightContent} key={rightContent}/>
    )
}

